import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

function MapMarker() {
  const data = useStaticQuery(graphql`
    query {
      sanitySiteSettings(_id: { eq: "siteSettings" }) {
        mapMarkerIcon {
          alt
          image {
            asset {
              gatsbyImageData(layout: FIXED, aspectRatio: 1, width: 60)
            }
          }
        }
      }
    }
  `);

  return (
    <div
      style={{
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <GatsbyImage
        alt={data.sanitySiteSettings?.mapMarkerIcon?.alt ?? ''}
        style={{ width: 60, height: 60 }}
        image={data.sanitySiteSettings?.mapMarkerIcon?.image?.asset?.gatsbyImageData ?? null}
      />
    </div>
  );
}

export default MapMarker;
